import React from "react";
import why from "../../images/articles/startWithWhy/why-img.png";
import how from "../../images/articles/startWithWhy/how-img.png";
import "../../styles/blogs.css";

const startWithWhyRememberHow = () => {
  return (
    <>
      <section className="blog">
        <div className="blogIntro">
          <h1>Start with the WHY. Remember the HOW</h1>
          <p>
            My partner was away recently, and I needed to prepare a healthy meal
            that was easy to cook and my kids enjoy eating. I chose fish pie but
            despite my best efforts it did not taste as good as fish pie
            prepared by professional chefs.
          </p>
          <p>
            This might sound like a simple common story from households across
            the globe, but on closer inspection there are remarkable
            similarities that relate to how learning is (or is not) embedded in
            organisations.
          </p>
        </div>
        <div className="blogPara">
          <h3>WHY?</h3>
          <img src={why} alt="Why, how, what" />
          <p>Let’s unpack our fish pie story in more detail…</p>
          <p>
            Simon Sinek has recently inspired the world to ‘Start with Why’ when
            you plan to communicate with impact. Why?(!) – because countless
            research has demonstrated that the part of our brain that makes
            decisions is motivated by the ‘why’. It is the very reason that
            organisational change initiatives and leadership courses have been
            highlighting this as critical to gaining buy-in for years.
          </p>
          <p>
            Being clear on my ‘why’ was the motivation needed in preparing that
            fish pie. Healthy, tasty and easy. If I could find something to tick
            those boxes, we weren’t having takeaway!
          </p>
        </div>
        <div className="blogPara">
          <h3>WHAT?</h3>
          <p>
            The ‘what’ focuses on logic, definitions and detail that are easily
            expressed with words. Humans are generally good at thinking in these
            terms. Business is littered with examples of well defined, logical
            information. Examples of this include:
          </p>
          <ul>
            <li>Organisational Goals</li>
            <li>Capability Frameworks & Communication Models</li>
            <li>Job descriptions</li>
            <li>Metrics and KPIs</li>
            <li>Marketing tools</li>
          </ul>
          <p>
            These tools are everywhere and employees understand the rationale
            for them.
          </p>
          <p>
            But something is missing because there many businesses with these
            tools alone are not delivering exceptional results. This is because
            there are rules for how they come alive and stay alive in
            organisations and they must be followed. Which explains why being
            clear on the ingredients and recipe for a fish pie certainly did not
            do the job for me.
          </p>
        </div>
        <div className="blogPara">
          <h3>HOW?</h3>
          <img src={how} alt="Football being kicked" />
          <p>How is hard to measure and how is hard to verbalise.</p>
          <p>
            David Beckham can explain in detail WHAT he is trying to do when he
            kicks a football and WHY, but he cannot explain exactly HOW he does
            it so well. Nobody has managed to ‘decode’ his technique in a way
            that can be replicated. What is clear is that Beckham spent hour
            after hour, week after week practicing to get it just right.
          </p>
          <p>
            Staying on this theme, in his book ‘Bounce’, former Olympic table
            tennis player Matthew Syed raises the topic of disciplined and
            deliberate practice. Syed presents diverse research that suggests
            one of the key differences between the very best in their field and
            the next best is thousands of hours of additional practice put in
            over the years. Disciplined, focused practice building systems,
            routines, habits and ultimately muscle memory.
          </p>
          <p>
            Similarly, David Beckham spent hours kicking a football through a
            car tyre that his uncle tied to a tree in his local park. It’s
            dedication and practice like this that made him so good.
          </p>
          <p>
            So… no wonder my fish pie was not cooked as well as the professional
            chefs cook it. I failed to put in the hours of cooking practice that
            they have.
          </p>
        </div>
        <div className="blogPara">
          <h3>IN CONCLUSION</h3>
          <p>
            In the pursuit of excellence, the relationship between WHY, WHAT and
            HOW is intertwined. Focus therefore should be placed on all three
            areas, but in a fast-paced organisation it is hard to remain
            disciplined in perfecting the HOW.
          </p>
          <p>
            At home it is ok for my fish pie to be average, but at work we are
            the professional chefs of our field. Mediocre just does not cut-it
            in our increasingly competitive world. There are rules for driving
            and managing performance that are being overlooked. Strategy trumps
            execution in most organisations, and even when we try to strike a
            balance, getting it right is hard.
          </p>
          <p>
            We’ve worked incredibly hard over the years at Healthcare
            Interaction to create the perfect methodology for HOW to succeed.
          </p>
          <p>
            It is true that we are behavioural change experts and our methods
            are backed by scientific research to provide a clear WHY.
          </p>
          <p>
            And yes, our tools and processes are defined to offer clarity and
            metrics for WHAT is important.
          </p>
          <p>
            But where we can help you to stand apart is by providing simple
            methods to bring and keep these things alive to solve your current
            and future business challenges.
          </p>
          <p>
            That’s how we have been successfully supporting clients for more
            than 20 years and why we have many cast-iron case studies to
            evidence the quality of our work.
          </p>
        </div>
      </section>
    </>
  );
};

export default startWithWhyRememberHow;
